var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25413 1.09956C7.01874 -0.259747 8.97582 -0.259748 9.74043 1.09956L15.3207 11.0201C16.0707 12.3533 15.1072 14.0006 13.5776 14.0006H2.41697C0.887321 14.0006 -0.0761066 12.3533 0.673823 11.0201L6.25413 1.09956ZM8.99719 11.0007C8.99719 11.553 8.54948 12.0007 7.99719 12.0007C7.44491 12.0007 6.99719 11.553 6.99719 11.0007C6.99719 10.4484 7.44491 10.0007 7.99719 10.0007C8.54948 10.0007 8.99719 10.4484 8.99719 11.0007ZM7.99719 3.00073C7.44491 3.00073 6.99719 3.44845 6.99719 4.00073V7.00073C6.99719 7.55302 7.44491 8.00073 7.99719 8.00073C8.54948 8.00073 8.99719 7.55302 8.99719 7.00073V4.00073C8.99719 3.44845 8.54948 3.00073 7.99719 3.00073Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.1c4a3991679d3a162edf58ec3ea8e76c.svg";
export { ForwardRef as ReactComponent };